import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function PrivateRoute({ children, adminOnly = false, allowProspect = false }) {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#050505", color: "#737373", fontSize: 12, letterSpacing: "0.22em", textTransform: "uppercase" }}>
        Cargando...
      </div>
    );
  }
  if (!user) return <Navigate to="/app/login" state={{ from: location }} replace />;
  if (user.role === "prospect" && !allowProspect) return <Navigate to="/app/incorporacion" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/app/dashboard" replace />;
  if (!adminOnly && user.role === "admin" && location.pathname.startsWith("/app/dashboard")) {
    return <Navigate to="/app/admin" replace />;
  }
  return children;
}
